<br-hero
  image="/assets/images/ext3.jpg"
  [colorize]="false"
  backgroundColor="var(--gray-50)"
>
</br-hero>

<br-page-layout brandIdentity="true">
  <br-section layout="left">
    <h2>{{ project }}: 25 prachtige appartementen</h2>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet quod culpa
      recusandae est beatae, dolor ab reprehenderit nemo a quam alias cum, harum
      et, totam cumque facilis aperiam. Autem, id. Lorem ipsum dolor sit amet,
      consectetur adipisicing elit. Aspernatur corporis soluta facere dolorum
      quae hic debitis iure, itaque voluptate consequuntur vero repudiandae nam
      sed, unde ab cupiditate? Quod, dicta, enim!
    </p>

    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Non quasi
      suscipit expedita nulla ducimus laborum veritatis libero dolor labore,
      rerum eius iure recusandae saepe, quam. Nobis enim, vero sapiente
      dignissimos.
    </p>
  </br-section>

  <br-section>
    <h2>De koopwoningen van {{ project }}</h2>
    <br-flex spacing="var(--big)">
      <br-card
        title="Type A"
        image="/assets/images/int1.jpg"
        meta="Appartement"
        clickable="true"
        size="wide"
        (click)="router.navigate(['type-a'])"
      >
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        </p>

        <p class="flush">
          <br-grid
            columns="max-content auto"
            columnGap="var(--regular)"
            rowGap="var(--small)"
          >
            <br-icon name="money-bill-wave" color="var(--gray-40)"></br-icon>
            <span>€380.000 - €420.00</span>

            <br-icon name="home" color="var(--gray-40)"></br-icon>
            <span>Appartement</span>

            <br-icon name="expand" color="var(--gray-40)"></br-icon>
            <span>100 m²</span>

            <br-icon name="bed" color="var(--gray-40)"></br-icon>
            <span>2 slaapkamers</span>
          </br-grid>
        </p>
      </br-card>

      <br-card
        title="Type B"
        image="/assets/images/int2.jpg"
        meta="Appartement"
        clickable="true"
        size="wide"
        (click)="router.navigate(['type-b'])"
      >
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        </p>

        <p class="flush">
          <br-grid
            columns="max-content auto"
            columnGap="var(--regular)"
            rowGap="var(--small)"
          >
            <br-icon name="money-bill-wave" color="var(--gray-40)"></br-icon>
            <span>€579.000 - €600.000</span>

            <br-icon name="home" color="var(--gray-40)"></br-icon>
            <span>Appartement</span>

            <br-icon name="expand" color="var(--gray-40)"></br-icon>
            <span>143 m²</span>

            <br-icon name="bed" color="var(--gray-40)"></br-icon>
            <span>3 slaapkamers</span>
          </br-grid>
        </p>
      </br-card>
    </br-flex>

    <br-flex spacing="var(--big)">
      <br-card
        title="Type C"
        image="/assets/images/int3.jpg"
        meta="Appartement"
        clickable="true"
        size="wide"
      >
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        </p>

        <p class="flush">
          <br-grid
            columns="max-content auto"
            columnGap="var(--regular)"
            rowGap="var(--small)"
          >
            <br-icon name="money-bill-wave" color="var(--gray-40)"></br-icon>
            <span>€600.000 - €625.000</span>

            <br-icon name="home" color="var(--gray-40)"></br-icon>
            <span>Appartement</span>

            <br-icon name="expand" color="var(--gray-40)"></br-icon>
            <span>157 m²</span>

            <br-icon name="bed" color="var(--gray-40)"></br-icon>
            <span>3 slaapkamers</span>
          </br-grid>
        </p>
      </br-card>

      <br-card
        title="Type D"
        image="/assets/images/ext6.jpg"
        meta="Appartement"
        clickable="true"
        size="wide"
      >
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        </p>

        <p class="flush">
          <br-grid
            columns="max-content auto"
            columnGap="var(--regular)"
            rowGap="var(--small)"
          >
            <br-icon name="money-bill-wave" color="var(--gray-40)"></br-icon>
            <span>€870.000</span>

            <br-icon name="home" color="var(--gray-40)"></br-icon>
            <span>Appartement</span>

            <br-icon name="expand" color="var(--gray-40)"></br-icon>
            <span>170 m²</span>

            <br-icon name="bed" color="var(--gray-40)"></br-icon>
            <span>4 slaapkamers</span>
          </br-grid>
        </p>
      </br-card>
    </br-flex>
  </br-section>

  <br-data-table
    tableId="demoproject-nl__woningen"
    title="Bouwnummers"
    [items]="woningen"
    [options]="{ sort: 'multi', clickable: true }"
    [columns]="[
      { key: 'bouwnummer', title: '#' },
      { key: 'status', template: status },
      { key: 'open', title: ' ', template: open }
    ]"
    (action)="selectBuildNumber($event)"
  >
    <ng-template let-data="data" #status>
      <br-indicator [state]="indicatorState(data)"></br-indicator>
    </ng-template>

    <ng-template #open>
      <br-icon-button
        name="angle-right"
        style="solid"
        type="table"
      ></br-icon-button>
    </ng-template>
  </br-data-table>
</br-page-layout>
